module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 text-center rank"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "amount-title"
  }, [_vm._v("Vàng")]), _vm._v(" "), _c('p', {
    staticClass: "text-center2"
  }, [_vm._v("Hạng thành viên")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2427e5be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/itemRank.vue
// module id = 1513
// module chunks = 0